import React, { Component } from 'react'
import { Box, Card, CardActionArea } from '@mui/material';
import { getCardWidth } from './KanbanHelper';
import AddIcon from '@mui/icons-material/Add';

class AddCardLink extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }
    render() {
        return (
            <div >
                <Card sx={{ margin: '5px', width: getCardWidth(this.props.data.lanes.length) + "px" }}>
                    <CardActionArea onClick={() => this.props.props.onClick()}>
                        <Box display={'flex'} flexDirection='row' alignItems={'center'}>
                            <Box m={1}>
                                <AddIcon fontSize='small' />
                            </Box>
                            <Box >
                                Add Work Order
                            </Box>
                        </Box>
                    </CardActionArea>
                </Card>
            </div>
        )
    }
}
// export default withSnackbar(AddCardLink)
export default AddCardLink;